import Highcharts from 'highcharts'
import Vue from 'vue';
import VueHighcharts from 'vue-highcharts';
import factoryVariablePie from 'highcharts/modules/variable-pie'
import factoryDrilldown from 'highcharts/modules/drilldown'

Highcharts.setOptions({
  time: {
    timezone: 'Europe/Moscow',
    timezoneOffset: -180,
  },
  lang: {
    shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
    resetZoom: "Cбросить масштаб"
  },

})

factoryVariablePie(Highcharts);
factoryDrilldown(Highcharts);
Vue.use(VueHighcharts);
